import { ComboboxOption } from '@headlessui/react';
import { twMerge } from 'tailwind-merge';

import { getTestProps } from '../../../lib/helpers';

import { CheckmarkIcon } from '../../../images/shapes';

const DropdownOption = ({
  option,
  groupName,
  additionalOptionsClasses,
  isVirtualScrolling,
  testId,
  ...props // headless ui passed props to combobox option
}) => {
  return (
    <ComboboxOption
      as="li"
      className={twMerge(
        'w-full',
        // When virtual scrolling there is some issue that every option has data-focus attribute
        isVirtualScrolling
          ? 'hover:bg-blue-300 dark:hover:bg-transparent'
          : 'focus:bg-blue-300 dark:data-[focus]:bg-transparent',
        'cursor-default select-none py-2 pl-4',
        groupName && 'pl-6',
        option.disabled
          ? 'bg-gray cursor-not-allowed'
          : 'hover:cursor-pointer hover:dark:bg-gray-700',
        additionalOptionsClasses,
        option.disabled && option.disabledAdditionClass,
      )}
      value={option.value}
      disabled={option.disabled}
      {...getTestProps(testId, `${option.value}-option`)}
      {...props}
    >
      {({ selected }) => (
        <div className="flex flex-row items-center justify-between">
          <span className="flex items-center truncate min-h-[21px] dark:text-white w-full">
            <span
              className={twMerge(
                'h-2 w-2 mr-2 rounded-full',
                option.circleColor || 'hidden',
              )}
            />
            {option.optionLabel || option.label || option.value}
          </span>
          <span className={twMerge('text-blue pr-1 md:pr-5')}>
            {selected && !option.ignoreCheckmark && (
              <CheckmarkIcon
                className="w-3.5 text-blue"
                {...getTestProps(testId, `${option.value}-selected`)}
              />
            )}
          </span>
        </div>
      )}
    </ComboboxOption>
  );
};

export default DropdownOption;
